export const STORE_SERVICE_LABELS = {
  POS_NUMBER: "POS Number",
  POS_NAME: "POS Name",
  POS_CATEGORY: "POS Category",
  POS_TYPE: "POS Type",
  SERVICE_TYPE: "Service Type",
  SERVICE_TYPES: "Service Types",

  //
  POS_DETAILS: "Pos Details",
  PRIMARY_INFORMATION: "Primary Information",
  ADDRESS_INFORMATION: "Address Information",
  CUSTOMER_SERVICE_DETAILS: "Customer Service Details",
  LOCATION_DETAILS: "Location Details",
  //
  NAME: "Name",
  EMAIL: "Email",
  ADDRESS: "Address",
  PHONE_NUMBER: "Phone Number",
  COORDINATES: "Coordinates",
  ACTIONS: "Actions",

  BILLING_POS: "Billing POS",
  FULFILLED_BY: "Fulfilled By",
  DELIVERED_BY: "Delivered By",
  FULFILLMENT_SYSTEM: "Fulfillment System",
  SERVICE_DETAILS: "Service Details",
};

export const ON_OFF_OPTIONS = [
  { value: true, label: "On" },
  { value: false, label: "Off" },
];


export const STORE_SERVICE_BUTTON_LABELS = {
  CURRENT_LOADING: "loading...",
  UPDATE_POS: "Update POS",
  CREATE_NEW_POS: "Create New POS",
  UPDATE: "UPDATE",
  SAVE_AND_PROCEED: "SAVE AND PROCEED",
  BACK_TO_POS: "Back to POS",
  CANCEL: "CANCEL",
  DELETE_POS: "DELETE POS",
}

export const STORE_SERVICE_MESSAGES = {
  POS_TYPE_SPECIAL_CHARACTER: "Special characters are not allowed for non-pharmacy POS types",
  POS_NUMBER_EMPTY: "Please enter POS number",
  POS_NUMBER_LENGTH: "POS number should have only 3 characters",
  LATITUDE_VALUE_ERROR: "Accepted values are from -90 to +90",
  LONGITUDE_VALUE_ERROR: "Accepted values are from -180 to +180",
  POS_NAME_EMPTY: "Please enter a valid POS name",
  POS_EMAIL_EMPTY: "Please enter valid email address!",
  PHONE_NUMBER_EMPTY: "Please enter valid phone number!",
  LATITUDE_EMPTY: "Please enter latitude",
  LONGITUDE_EMPTY: "Please enter longitude",
  DELETE_POS_ERROR_MESSAGE: "Error deleting POS. Please try again.",
}

export const STORE_SERVICE_SUCCESS_MESSAGES = {
  POS_CREATED: "POS created successfully",
  POS_UPDATED: "POS details updated successfully",
  POS_DELETED: "POS deleted successfully",
}

/**
 * ENHANCEMENTS: below enum is used to identify different UI elements
 * This helps in identifying elements in tests and improving test reliability
 */
export enum ELEMENT {
  TABLE = 'table',
  TABLE_ROW = 'tableRow',
  TABLE_CELL = 'tableCell',
  SELECT_DROPDOWN = 'selectDropdown',
  TYPOGRAPHY = "span",
  DIV = "div",
  GRID = "grid",
  BUTTON = "button",
  TEXTAREA = "textArea",
  SVG_ICON = "svgIcon",
  TEXT_BOX = "textBox",
  POP_OVER = "popOver",
};

/**
 * ENHANCEMENTS: below enum is used to identify different data elements
 * This helps in identifying elements in tests and improving test reliability
 * both the UI and data elements combined creates a unique identifier for each element
 */
export enum DATA_IDENTIFIER {
  POS_LIST = 'posList',
  SERVICE_TYPE = 'serviceType',
  SETTINGS = 'settings',
  POS_TYPE = 'posType',
  STATUS = 'status',
  PAGE_TITLE = 'pageTitle',
  LOADER = 'loader',
  DAY = 'day',
  TIME = 'time',
  CAPACITY = 'capacity',
  BUFFER_TIME = 'bufferTime',
  ORDER_CUT_OFF = 'orderCutOff',
  SLOTS = 'slots',
  REQUESTED_SLOTS = 'requestedSlots',
  APPROVE = 'approve',
  REJECT = 'reject',
  APPROVER_COMMENT = 'approverComment',
  CLEAR_ALL_FILTERS = 'clearAllFilters',
  DATE_RANGE_PICKER = 'dateRangePicker',
  POP_OVER_TRIGGER = 'popOverTrigger',
  APPLY = "apply",
  RESET = "reset",
  PAGINATION = "pagination",
  POS_NO_NAME_FILTER = "posNoNameFilter",
  POP_OVER = "popOver",
  CLOSE_ICON = "closeIcon",
  TOAST_CONTAINER = "toastContainer",
  TOP_MENU = "topMenu",
  SIDE_MENU = "sideMenu",
  MAIN = "main",
  CANCEL = "cancel",
  ZONE_NAME = "zoneName",
  ACCEPTING_ORDERS = "acceptingOrders",
  POS_NAME = "posName",
  BACKDROP = "backdrop",
  ESCAPE = "escape",
  GENERIC = "generic",
  MINIMUM_DAYS = "minimumDays",
  MAXIMUM_DAYS = "maximumDays",
  CUT_OFF = "cutOff",
  PRIORITY_FEE = "priorityFee",
  VIEW_BASIC_DETAIL = "viewBasicDetail",
  STANDARD_SLOTS = "standardSlots",
  EXPRESS_SLOTS = "expressSlots",
  DEFAULT_SLOTS = "defaultSlots"
}

export const LABELS = {
  CLEAR_ALL_FILTERS: "Clear all Filters",
};

export const SERVICE_TYPES_IDS = {
  DEFAULT: "1",
  STANDARD: "2",
  EXPRESS: "3",
};

export const FULFILLMENT_OPTIONS = {
  OWN: "Own",
  THIRD_PARTY: "Third Party",
}

export const FULFILLMENT_SYSTEM_OPTIONS = {
  ALECTO: "Alecto",
  NEPTUNE: "Neptune",
  IMILE: "iMile",
}

export const FULFILLMENT_DROPDOWN_OPTIONS = [
  { id: FULFILLMENT_OPTIONS.OWN, name: "Own" },
  { id: FULFILLMENT_OPTIONS.THIRD_PARTY, name: "Third Party" },
]

export const FULFILLMENT_SYSTEM_DROPDOWN_OPTIONS = [
  { id: FULFILLMENT_SYSTEM_OPTIONS.ALECTO, name: "Alecto" },
  { id: FULFILLMENT_SYSTEM_OPTIONS.NEPTUNE, name: "Neptune" },
  { id: FULFILLMENT_SYSTEM_OPTIONS.IMILE, name: "iMile" },
]

